import "@/index.css";
import "@/App.css";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { getAdminToken } from "@/lib/api";
import Login from "@/pages/Login";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Channels from "@/pages/Channels";
import Tariffs from "@/pages/Tariffs";
import Subscriptions from "@/pages/Subscriptions";
import Payments from "@/pages/Payments";
import PaymentMethods from "@/pages/PaymentMethods";
import PromoCodes from "@/pages/PromoCodes";
import AutoRepost from "@/pages/AutoRepost";
import Settings from "@/pages/Settings";
import Stats from "@/pages/Stats";
import BotPreview from "@/pages/BotPreview";
import Admins from "@/pages/Admins";
import Packages from "@/pages/Packages";
import Broadcasts from "@/pages/Broadcasts";
import Referrals from "@/pages/Referrals";

function RequireAuth({ children }) {
  if (!getAdminToken()) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function App() {
  return (
    <div className="min-h-screen bg-[#050505]">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/bot-preview" element={<RequireAuth><BotPreview /></RequireAuth>} />
          <Route path="/*" element={
            <RequireAuth>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/channels" element={<Channels />} />
                <Route path="/packages" element={<Packages />} />
                <Route path="/tariffs" element={<Tariffs />} />
                <Route path="/subscriptions" element={<Subscriptions />} />
                <Route path="/payments" element={<Payments />} />
                <Route path="/payment-methods" element={<PaymentMethods />} />
                <Route path="/promo-codes" element={<PromoCodes />} />
                <Route path="/broadcasts" element={<Broadcasts />} />
                <Route path="/referrals" element={<Referrals />} />
                <Route path="/auto-repost" element={<AutoRepost />} />
                <Route path="/admins" element={<Admins />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/stats" element={<Stats />} />
              </Routes>
            </Layout>
            </RequireAuth>
          } />
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="top-right"
        toastOptions={{
          style: {
            background: '#0a0a0a',
            border: '1px solid rgba(255,255,255,0.1)',
            color: '#fff',
          },
        }}
      />
    </div>
  );
}

export default App;
